export default "__VITE_ASSET__3i4fDoRO__"